import React from 'react';
import { Building, Target } from 'lucide-react';

const AboutUs: React.FC = () => {
  return (
    <div className="bg-background text-foreground">
      <div className="container mx-auto px-4 py-16 sm:py-24">
        <div className="max-w-4xl mx-auto">
          {/* About Section */}
          <div className="mb-16">
            <div className="flex items-center justify-center mb-6">
              <Building className="w-10 h-10 sm:w-12 sm:h-12 text-primary" />
              <h1 className="text-4xl sm:text-5xl font-bold text-secondary ml-4">
                About Udyoga Pramoda
              </h1>
            </div>
            <div className="bg-surface p-8 rounded-2xl shadow-lg border border-border">
              <p className="text-lg text-gray-700 leading-relaxed">
                Udyoga Pramoda, the brainchild of HH Sri Sri 1008 Sri Satyatmateertha Swamiji, is an
                initiative by Uttaradi Math, Bhagyanagara. Launched by HH himself on January 4, 2025, the
                initiative aims to empower Brahmin youth, particularly fresh graduates and unemployed
                individuals, by providing skill development, mentorship, and job placement support.
                Through structured training and guidance, the initiative seeks to bridge the skill gap and
                connect job aspirants with meaningful career opportunities.
              </p>
            </div>
          </div>

          {/* Vision Section */}
          <div>
            <div className="flex items-center justify-center mb-6">
              <Target className="w-10 h-10 sm:w-12 sm:h-12 text-primary" />
              <h2 className="text-4xl sm:text-5xl font-bold text-secondary ml-4">
                Our Vision
              </h2>
            </div>
            <div className="bg-surface p-8 rounded-2xl shadow-lg border border-border">
              <p className="text-lg text-gray-700 leading-relaxed">
                To establish a self-sustaining ecosystem that seamlessly integrates mentorship, skill
                development, career coaching, and job placements—empowering job aspirants for
                success while strengthening the professional community within the Brahmin society.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 